// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__TCzvV","content":"layout_content__c_zCv"};